"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ProductUtilities_1 = require("../ProductUtilities");
/** @ignore Enumeration for the display values of credit card payment origins */
exports.displayOrigin = {
    ach: 'ACH',
    autopay: 'Autopay',
    check: 'Check'
};
/**
 * Returns formated origin to display for customer.
 *
 * @param origin This string should be one of `online`/`autopay`/`check`.
 * @returns the proper display value for the payment origin type, or `null` if there is no matching display value
 * @deprecated use `creditCardPaymentFormatPaymentMethodForDisplay` instead.
 */
exports.creditCardPaymentFormatOriginForDisplay = (origin) => {
    switch (origin) {
        case 'online':
            return exports.displayOrigin.ach;
        case 'autopay':
            return exports.displayOrigin.autopay;
        case 'check':
            return exports.displayOrigin.check;
        default:
            return null;
    }
};
/** @ignore Enumeration for the display values of credit card payment methods */
exports.displayPaymentMethod = {
    ach: 'ACH',
    debitCard: 'Debit Card',
    check: 'Check'
};
/**
 * Returns formatted payment method to display for customer.
 *
 * @param paymentMethod This string should be one of `ach`/`debit_card`/`paper_check`.
 * @returns the proper display value for the payment method type, or `null` if there is no matching display value
 */
exports.creditCardPaymentFormatPaymentMethodForDisplay = (paymentMethod) => {
    switch (paymentMethod) {
        case 'ach':
            return exports.displayPaymentMethod.ach;
        case 'debit_card':
            return exports.displayPaymentMethod.debitCard;
        case 'paper_check':
            return exports.displayPaymentMethod.check;
        default:
            return null;
    }
};
/** @ignore Valid statuses of a credit card product */
var CreditCardStatus;
(function (CreditCardStatus) {
    CreditCardStatus["active"] = "active";
    CreditCardStatus["issued"] = "issued";
    CreditCardStatus["closed"] = "closed";
})(CreditCardStatus = exports.CreditCardStatus || (exports.CreditCardStatus = {}));
/**
 * Returns a subset of products that are credit cards.
 *
 * @param products a collection of credit cards and/or loans to filter.
 * @returns a subset of the input products that are credit card accounts
 */
exports.creditCardsFromProducts = (products) => ProductUtilities_1.destructure(products)
    .filter(exports.isCreditCard);
/**
 * Returns a subset of credit cards with `issued` status.
 *
 * @param products a collection of credit cards and/or loans to filter.
 */
exports.issuedCreditCards = (products) => exports.creditCardsFromProducts(products)
    .filter(creditCard => creditCard.status === CreditCardStatus.issued);
/**
 * This check, although it is on product status, is used to determine whether all credit card related UI should be shown.
 *
 * @param products a collection of credit cards and/or loans to filter.
 * @returns `true` if the list of products includes an `active` or `issued` credit card account, `false` if otherwise
 */
exports.isCreditCardCustomer = (products) => exports.creditCardsFromProducts(products)
    .some(({ status }) => status === CreditCardStatus.active || status === CreditCardStatus.issued);
/**
 * Casts Product to be of type `CreditCard` within the scope of the if statement if the product is a `CreditCard`.
 * @param product is a credit card or loan account
 * @returns the product cast into a `CreditCard` if possible, and returns `false` if not
 */
exports.isCreditCard = (product) => (product.__typename === 'CreditCardAccount');
/**
 * Returns `true` if `currentBalance` has a balance.
 *
 * @param currentBalance a parameterized money fragment
 * @returns `true` if current balance is present and has an `amount` of more than 0
 */
exports.creditCardHasBalance = (currentBalance) => currentBalance !== null && currentBalance.amount > 0;
